<template>
<div class="container-full-width default-container p-3">
    <filtro 
        :showfiltro="showFiltro"
        :params="paramsFiltro" 
        @change="filtroChange"
        @cancel="handleCloseFiltro"
      />
    <div class="row">
      <div class="col-12 lbl-deal-title mb-2">
        <span class="lbl-deal-title mb-2 w-100">Consulta Movimentação de Estoque </span>
        <v-button label="Retornar para visões" icon="fa-bar-chart" class="float-right" @click="clickRetornar()"></v-button>
      </div>
    </div>
    <hr />
    <div class="row mb-3 align-items-end">
      <div class="col-md-5 col-12">
        <label-title label="Período" />
        <input-month2 :p-month="monthObj" @change="periodoChange"></input-month2>
      </div>
      <div class="col-md-4 col-12">
        <input-search
          label="Pesquisar item"
          v-model="itemPesquisa"
          entity="item"
          @change="handleItemSelect"
        />
      </div>
      <div class="col-md-3 col-12">
        <v-button icon="fa-search" :success="true" @click="handleSearch" class="mt-4 mr-2"></v-button>
        <v-button icon="fa-filter" :success="true" @click="handleShowFiltro" class="mt-4" title="Mais filtros"></v-button>
      </div>
    </div>
    <hr>
    <div class="row mb-5">
       <div class="col-12 lbl-deal-title mb-2">
           MOVIMENTAÇÕES
            <v-button label="Excel" class="float-right" @click="loadData(true)"></v-button>
       </div>
       <div class="col-12" v-for="(produto, i) in dados.items" :key="i">
            <div class="lbl-deal-title mb-2 mt-4" style="font-size: 14px; background: #f8f9fa; padding: 10px; border-radius: 4px;">
              <strong>{{produto.codigo}} - {{produto.descricao}} <span v-if="produto.linha || produto.coluna"> ({{produto.linha}} / {{produto.coluna}})</span></strong>
              <span class="float-right">Entradas: {{produto.total_entradas | formatValue(2)}} | Saídas: {{produto.total_saidas | formatValue(2)}}</span>
            </div>
            <div class="px-4">
              <div style="width: 100%; max-height: 100%; overflow: hidden; font-size: 12px">
                  <div style="overflow: auto">
                      <table class="table table-striped table-hover responsive tablesorter w-100">
                          <thead>
                              <tr style="height: 37px">
                                  <th class="textual header col-1 d-none d-md-table-cell"  title="">Data</th>
                                  <th class="textual header col-auto d-none d-md-table-cell"  title="">Tipo</th>
                                  <th class="numerico header col-auto"  title="">Quantidade</th>
                                  <th class="textual header col-auto d-none d-md-table-cell"  title="">Uni</th>
                                  <th class="textual header col-auto d-none d-md-table-cell"  title="">Usuário</th>
                                  <th class="textual header col-auto"  title="">Cliente/Fornecedor</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr style="height: 37px" v-for="(row, j) in produto.movimentos" :key="j">
                                  <td class="textual d-none d-md-table-cell">{{row.data | formatData}}</td>
                                  <td class="textual d-none d-md-table-cell"> {{row.tipo}}</td>
                                  <td class="numerico">{{row.quantidade | formatValue(2)}}</td>
                                  <td class="textual d-none d-md-table-cell">{{row.unidade}}</td>
                                  <td class="textual d-none d-md-table-cell">{{row.usuario}}</td>
                                  <td class="textual">{{row.part}}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
            </div>
       </div>
   </div>
</div>

</template>

<script>
import DashCard from '../dashboards/dash-card'
import Chart from './chart'
import Filtro from './filtro'
import InputSearch from '../components/input-search'
import InputMonth2 from '../components/input-month2'
import LabelTitle from '../components/label-title'
import { SysVars } from '../main'
import { apiORDSpost, apiDownload2 } from '../shared/api-functions'

export default {
    components: {
        DashCard, Filtro, Chart, InputSearch, LabelTitle, InputMonth2
    },
    data () {
        return {
            showFiltro: false,
            dados : {},
            itemPesquisa: null,
            nextPage: false,
            monthObj: {
              startDate: null,
              endDate: null
            },
            paramsFiltro: {
                checkbox:[
                ],
                filtros: [
                    { nome: 'grupoestoque', label: null, url: null, varios: true, values: [] },
                    { nome: 'clientefornecedor', label: null, url: null, varios: true, values: [] },
                ],
            },
            filtro:{
                data_inicio: null,
                data_termino: null,
                produto: [],
                fornecedor: [],
                grupoestoque: [],
                page: 1
            }
        }
    },
    methods:{
        handleCloseFiltro(){
            this.showFiltro = false
        },
        handleCancel(){
            this.showFiltro = false
        },
        filtroChange(filtro){
          this.filtro.grupoestoque = filtro.grupoestoque || [];
          this.filtro.fornecedor = filtro.clientefornecedor || [];
          this.filtro.page = 1;
          this.showFiltro = false
        },
        clickRetornar () {
          this.$router.push('/')
        },

        handleShowFiltro(){
            this.showFiltro = true
        },

        periodoChange (start, end) {
          this.filtro.data_inicio = start
          this.filtro.data_termino = end
          this.filtro.page = 1
        },

        handleItemSelect(item) {
          this.filtro.produto = [item.id || item.codigo]
          this.filtro.descricao = null
          this.filtro.page = 1
        },

        handleSearch() {
          if (this.itemPesquisa) {
            // Se o que está no input é diferente do ID selecionado, tratamos como busca por descrição
            if (!this.filtro.produto || this.filtro.produto.length === 0 || this.itemPesquisa !== this.filtro.produto[0]) {
              this.filtro.descricao = this.itemPesquisa
              this.filtro.produto = []
            }
          } else {
            this.filtro.descricao = null
            this.filtro.produto = []
          }
          this.filtro.page = 1
          this.loadData()
        },

        scroll () {
          window.onscroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            const windowHeight = window.innerHeight
            const scrollHeight = document.documentElement.scrollHeight

            if (scrollTop + windowHeight >= scrollHeight - 10) {
              if (this.dados.has_more && !this.nextPage) {
                this.loadData(false, true)
              }
            }
            SysVars.scrollPosition = scrollTop
          }
        },

        async loadData(excel, loadMore) {

           let url = "consulta/estoque/movimentacaoestoque";

           if (loadMore) {
             if (this.dados.has_more && !this.nextPage) {
               this.filtro.page = this.dados.next_page
               this.nextPage = true
             } else {
               return
             }
           } else {
             if (!excel) {
                 this.filtro.page = 1
             }
           }

           this.filtro.excel = excel

           if (excel) {
             apiDownload2(this, url, this.filtro, "post")
           } else {
             const data = await apiORDSpost(this.$store, url, this.filtro, "post")
             if (data) {
               if (loadMore && this.dados.items) {
                 this.dados.items.push(...data.items)
                 this.dados.has_more = data.has_more
                 this.dados.next_page = data.next_page
               } else {
                 this.dados = data
               }
             } else {
               if (!loadMore) {
                 this.dados = { items: [] };
               }
             }
           }

           let self = this
           this.$nextTick(function () {
             self.nextPage = false
           })

        },

    },
    mounted() {
      this.scroll()
    },

    destroyed () {
      window.onscroll = null
    },

    created() {
      // Inicia com o mês atual para evitar consulta gigantesca
      const hoje = new Date()
      const dataInicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
      
      this.filtro.data_inicio = dataInicio.toISOString().split('T')[0]
      this.filtro.data_termino = hoje.toISOString().split('T')[0]
      
      this.monthObj.startDate = this.filtro.data_inicio
      this.monthObj.endDate = this.filtro.data_termino
    },
}

</script>

<style>

table .numerico {
    min-width:65px; 
    text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/consultas/consulta-movimento-estoque.vue